import i18next from 'i18next'
import React, { FormEventHandler, useEffect, useState } from 'react'
import { navigate } from 'widgets-for-react'

export function SearchBlock(props: {
  query: string
  page: number
  disabled?: boolean
}) {
  // @todo: Move to global state
  const [query, setQuery] = useState(props.query)
  const location = window.location

  // @todo: get rid of useeffect
  useEffect(() => {
    setQuery(props.query)
  }, [props.query])

  const onFormSubmit: React.FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault()
    navigate(
      `${location.pathname}?${new URLSearchParams({
        page: '1',
        search: query
      }).toString()}`
    )
  }

  return (
    <section className="block block--search">
      <div className="block__inner container--s spacing--m gutter--m">
        <header className="block__header">
          <h2 className="block__title title--m">{i18next.t('search:title')}</h2>
        </header>

        <div className="block__content">
          <div className="blockform blockform--search">
            <div className="blockform__inner">
              <SearchForm onFormSubmit={onFormSubmit} query={query} setQuery={setQuery} showButtonLabel={true} placeholder={i18next.t('search:placeholder')}/>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export const SearchForm = (p: {
  onFormSubmit: FormEventHandler<HTMLFormElement>
  query: string
  setQuery: (value: string) => void
  disabled?: boolean
  showButtonLabel: boolean
  placeholder: string
}) => {
  return (
    <form className='blockform__form' onSubmit={p.onFormSubmit}>
      <label className="sr-text" htmlFor="a11y-search">
        {i18next.t('search:label')}
      </label>
      <input
        className="blockform__input"
        id="a11y-search"
        name="search"
        type="search"
        placeholder={p.placeholder}
        value={p.query}
        onChange={e => p.setQuery(e.target.value)}
        disabled={p.disabled}
      />
      <button
        disabled={p.disabled}
        type="submit"
        className="blockform__button button button--primary button--icon"
      >
        {p.showButtonLabel && (<span className="button__label">
          {i18next.t('search:search')}
        </span>)}
        <svg className="button__icon" width="18px" height="18px">
          <use xlinkHref="#icon--search" />
        </svg>
      </button>
    </form>
  )
}

